<template>
  <v-dialog v-model="paymentModal" persistent max-width="980">
    <v-card v-if="paymentModal">
      <v-card-title>
        <h5
          class="modal-title d-inline-block"
          v-if="refundPayment.order && refundPayment.order.basic.number"
        >
          Возврат по заказу №{{ refundPayment.order.basic.number }}
        </h5>
        <h5 class="modal-title d-inline-block" v-else>
          Заказ №<span data-test-id="orderId">{{ order.id }}</span> выполнен
        </h5>
        <v-spacer />
        <v-btn
          v-if="!paymentInProgress && !paymentCompleted && !refundPayment.state"
          icon
          @click="paymentModal = false"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text v-if="refundPayment.state && !paymentInProgress">
        <h5>Возврат средств на карту</h5>
      </v-card-text>
      <v-card-text v-else-if="centrifugeConnecting">
        <v-row>
          <v-col class="text-center">
            <v-row>
              <v-col>
                <h5>
                  {{ paymentStatus }}
                </h5>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-img
                  :src="errorImage"
                  class="mr-auto ml-auto"
                  width="300"
                  height="300"
                  contain
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h3>
                  Нет связи с сервером кассы.
                  <br />
                  Пытаюсь подключится, ничего не трогай.
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-spacer />
                <v-btn class="ml-auto on-work" @click="paymentModal = false">
                  закрыть
                </v-btn>
                <v-spacer />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-else-if="paymentInProgress">
        <v-row>
          <v-col class="text-center">
            <div class="text-center mb-3">Ожидайте</div>
            <div>{{ paymentStatus }}</div>
            <v-row v-if="paymentStatusNum == 3">
              <v-col>
                <v-img
                  :src="
                    require('../../../assets/images/services/ready/pos.gif')
                  "
                  width="250"
                  height="250"
                  contain
                  class="mr-auto ml-auto"
                />
              </v-col>
              <v-col v-if="refundPayment.state" cols="12" class="text-center">
                <h5>Следуйте инструкциям на банковском терминале.</h5>
                <h5>
                  И, пожалуйста, подождите, пока мы получим ответ от банка...
                </h5>
              </v-col>
            </v-row>
            <v-row v-if="paymentStatusNum == 5">
              <v-col>
                <v-spacer />
                <v-img
                  :src="
                    require('../../../assets/images/services/ready/200w.gif')
                  "
                  width="250"
                  height="250"
                  contain
                  class="mr-auto ml-auto"
                />
                <v-spacer />
              </v-col>
            </v-row>
            <v-progress-linear
              :value="currentPaymentStatus"
              :buffer-value="100"
              color="amber"
              height="25"
              rounded
              striped
              stream
            ></v-progress-linear>
            <v-row
              class="mt-9 pb-9"
              v-if="paymentType !== 'cash' && clientType !== 'legal'"
            >
              <div class="bold">
                ДЛЯ ОТМЕНЫ ОПЕРАЦИИ ПО БАНКОВСКОЙ КАРТЕ НЕОБХОДИМО НАЖАТЬ
                КРАСНУЮ КНОПКУ ОТМЕНЫ НА БАНКОВСКОМ ТЕРМИНАЛЕ
                <br />
                <br />
                КАТЕГОРИЧЕСКИ ЗАПРЕЩЕНО ПЕРЕЗАГРУЖАТЬ СТРАНИЦУ ИЛИ ИСПОЛЬЗОВАТЬ
                КНОПКУ "НАЗАД" В БРАУЗЕРЕ.
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-else-if="paymentCompleted">
        <v-row>
          <v-col class="text-center">
            <v-row>
              <v-col>
                <h5 class="modal-title p-4 d-inline-block">
                  Спасибо большое, ждем Вас снова!
                </h5>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-img
                  src="/images/services/ready/end.png"
                  class="my-4 ml-auto mr-auto"
                  contain
                  width="300"
                  height="300"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-spacer />
                <v-btn class="ml-auto on-work" @click.prevent="returnHome()">
                  Погнали дальше!
                </v-btn>
                <v-spacer />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-else-if="paymentError">
        <v-row>
          <v-col class="text-center">
            <v-row>
              <v-col>
                <h5>
                  {{ paymentStatus }}
                </h5>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-img
                  :src="errorImage"
                  class="mr-auto ml-auto"
                  width="300"
                  height="300"
                  contain
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h3>
                  <span v-for="(code, index) in paymentErrorCode" :key="code">
                    {{ code
                    }}<template v-if="index < paymentErrorCode.length - 1"
                      >,
                    </template>
                  </span>
                </h3>
                <h5>
                  <span
                    v-for="(text, index) in paymentErrorTextFiltered"
                    :key="text"
                  >
                    {{ text
                    }}<template
                      v-if="index < paymentErrorTextFiltered.length - 1"
                      >,
                    </template>
                  </span>
                </h5>
                <br />
                <h5
                  v-if="paymentCustomErrorText"
                  v-html="paymentCustomErrorText"
                />
              </v-col>
            </v-row>
            <v-row v-if="errorHint">
              <v-col>
                <v-alert border="top" type="info" elevation="2">
                  <template #default>
                    <div class="text-h5" v-html="compHint"></div>
                  </template>
                </v-alert>
              </v-col>
            </v-row>
            <v-row v-if="showErrorInfo(paymentErrorCode)">
              <div class="accordion w-100" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button
                      @click="showErrorAccordion = !showErrorAccordion"
                      class="
                        text-center
                        v-btn v-btn--is-elevated v-btn--has-bg
                        theme--dark
                        v-size--default
                      "
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Посмотреть ошибку
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    class="accordion-collapse collapse"
                    :class="{
                      show: showErrorAccordion,
                    }"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <pre
                      class="accordion-body text-left"
                      v-html="paymentErrorJson"
                    />
                  </div>
                </div>
              </div>
            </v-row>
            <v-row>
              <v-col>
                <v-spacer />
                <v-btn
                  v-if="showReprint(paymentErrorCode)"
                  class="ml-auto on-work"
                  @click="sendReprint"
                >
                  Напечатать заново
                </v-btn>
                <v-spacer />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-spacer />
                <v-btn class="ml-auto on-work" @click="paymentModal = false">
                  закрыть
                </v-btn>
                <v-spacer />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-else-if="showMixedTypeInputs">
        <div class="double-play">
          <div class="text-big double-play__title">
            Введите сумму оплаты картой и наличными
          </div>
          <div class="double-play__content">
            <div class="text-center mb-6 text-big">
              Общая стоимость: {{ orderPrice }} ₽
            </div>
            <div class="d-flex align-center justify-center">
              <label class="mr-1">
                <div class="text-big">Наличными</div>
                <div class="d-flex align-center justify-center">
                  <button
                    class="control-button control-button--red text-medium"
                    @mousedown="plus('inputValueByCard', 'start')"
                    @mouseup="plus('inputValueByCard', 'end')"
                    @mouseout="deleteInterval"
                    @click="inputValueByCard++"
                  >
                    -
                  </button>
                  <input
                    v-model.number="inputValueByCash"
                    class="form-control text-medium"
                    type="number"
                  />
                  <button
                    @mousedown="plus('inputValueByCash', 'start')"
                    @mouseup="plus('inputValueByCash', 'end')"
                    @mouseout="deleteInterval"
                    @click="inputValueByCash++"
                    class="control-button text-medium"
                  >
                    +
                  </button>
                </div>
              </label>
              <label class="ml-1">
                <div class="text-big">Картой</div>
                <div class="d-flex align-center justify-center">
                  <button
                    class="control-button text-medium"
                    @click="inputValueByCash++"
                    @mousedown="plus('inputValueByCash', 'start')"
                    @mouseup="plus('inputValueByCash', 'end')"
                    @mouseout="deleteInterval"
                  >
                    -
                  </button>
                  <input
                    class="form-control text-medium"
                    type="number"
                    v-model.number="inputValueByCard"
                    data-test-id="mixCardInput"
                  />
                  <button
                    @mousedown="plus('inputValueByCard', 'start')"
                    @mouseup="plus('inputValueByCard', 'end')"
                    @mouseout="deleteInterval"
                    class="control-button control-button--red text-medium"
                    @click="inputValueByCard++"
                  >
                    +
                  </button>
                </div>
              </label>
            </div>
            <v-btn
              data-test-id="payMix"
              class="text-big button-send"
              @click="sendPayment(inputValueByCard, inputValueByCash, 'mixed')"
            >
              Оплатить
            </v-btn>
          </div>
        </div>
      </v-card-text>
      <v-card-text v-else>
        <client-card :actionsAllowed="true"></client-card>
        <div class="to-pay my-6"><h2>К оплате</h2></div>
        <v-row>
          <v-col class="d-flex align-items-center justify-content-cente">
            <div class="total pa-6 mr-auto ml-auto">
              <b class="rubl total-price">
                {{ cart.sum ? numberWithSpaces(cart.sum) : 0 }} ₽
              </b>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="w-100 bonus-alert mb-0 active text-center">
              <p class="m-0">— Оплата картой или наличными?</p>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col
              class="d-flex justify-content-around pt-0"
              :class="avblBtns && avblBtns.length> 3 ? 'flex-wrap' : ''"
          >
            <template v-for="(btn, indx) in avblBtns">
              <div
                :key="'btn-' + indx"
                style="width: 250px"
                v-if="disableButton(btn)"
                class="text-center ma-5"
              >
                <v-btn
                  @click="
                    sendPayment(
                      btn.action === 'card' ? order.sum : 0,
                      btn.action === 'card' ? 0 : order.sum,
                      btn.action
                    )
                  "
                  width="250"
                  height="160"
                  :data-test-id="btn.action"
                  color="white"
                >
                  <v-img
                    :src="
                      require('../../../assets/images/services/ready/' +
                        btn.img)
                    "
                    aspect-ratio="1.7"
                    contain
                  />
                </v-btn>
                {{ btn.text }}
              </div>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import errorsHints from "../errorsHint.json";
// import axios from "../../../plugins/axios-common";

export default {
  name: "paymentModal",
  components: {
    clientCard: () => import("./ClientCard.vue"),
  },
  data() {
    return {
      lastState: null,
      paymentState: null,
      errorsHints: errorsHints,
      subscriptionDone: false,
      subscription: null,
      paymentType: null,
      showErrorAccordion: false,
      paymentCompleted: false,
      paymentError: false,
      checkedPayment: false,
      paymentErrorText: [],
      paymentErrorJson: null,
      paymentErrorCode: [2000],
      interval: null,
      paymentStatus: null,
      paymentStatusNum: null,
      currentPaymentStatus: 0,
      paymentInProgress: false,
      showMixedTypeInputs: false,
      inputValueByCash: null,
      inputValueByCard: null,
      btns: [
        {
          text: "по карте",
          img: "visa.png",
          action: "card",
        },
        {
          text: "наличные и карта",
          img: "mixpayment.jpeg",
          action: "mix",
        },

        {
          text: "наличные",
          img: "cash.png",
          action: "cash",
        },
        {
          text: "наличные без фиск.",
          img: "cashFL.png",
          action: "cashfiscalless",
        },
        {
          text: "",
          img: "invoice.png",
          action: "Cashless",
        },
        {
          text: "",
          img: "invoice.png",
          action: "Maxdiscount",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["order", "clientType", "cart"]),
    ...mapGetters({
      autoAcquiring: "shift/shiftAutoAcquiring",
      orderInfo: "shift/orderInfo",
      shiftData: "shift/shiftData",
      centrifugeConnecting: "login/centrifugeConnecting",
      workshopInfo: "login/workshopInfo",
    }),
    errorHint() {
      const hintIndex = this.errorsHints.findIndex(
        (x) => !!~this.paymentErrorCode.findIndex((z) => z == x.code)
      );
      if (hintIndex >= 0) {
        return this.errorsHints[hintIndex];
      } else {
        return null;
      }
    },
    compHint() {
      let hintText = "";
      if (this.errorHint) {
        if (this.paymentType === "cash") {
          hintText = this.errorHint.hintCash;
        } else {
          hintText = this.errorHint.hint;
        }
      }
      return hintText;
    },
    errorImage() {
      if (
        this.paymentErrorCode.includes(2000) ||
        this.paymentErrorCode.includes("2000")
      ) {
        return require("../../../assets/images/services/ready/error2000.jpg");
      }

      if (this.paymentErrorCode.includes(4)) {
        return require("../../../assets/images/services/ready/error4.png");
      }

      return require("../../../assets/images/services/ready/Warningsign.png");
    },
    paymentCustomErrorText() {
      if (
        this.paymentErrorCode.includes(2000) ||
        this.paymentErrorCode.includes("2000")
      ) {
        return "КЛИЕНТ ОТМЕНИЛ ОПЕРАЦИЮ НА ТЕРМИНАЛЕ";
      }

      if (this.paymentErrorCode.includes(4)) {
        return (
          "Проверь шнур от Атола к компьютеру <br>" +
          "Проверь включен ли Атол <br>" +
          "Проверь шнур питания Атола <br>"
        );
      }

      return "";
    },
    paymentErrorTextFiltered() {
      return this.paymentErrorText.filter((item) => item !== "Ошибок нет");
    },
    refundPayment() {
      return this.$store.getters.paymentRefund;
    },
    orderPrice() {
      return +this.order.sum;
    },
    ctrlJobId: {
      get() {
        return this.$store.getters.ctrlJobId;
      },
      set(id) {
        this.$store.dispatch("setCtrlJobId", id);
      },
    },
    paymentModal: {
      get() {
        return this.$store.getters.paymentModal;
      },
      set(newVal) {
        this.$store.dispatch("setPaymentModal", newVal);
      },
    },
    avblBtns() {
      const fArr = this.btns.filter((val) => {
        if (this.clientType === "legal") {
          return val.action === "Cashless";
        } else if (
          this.order.sum == 0 &&
          this.order.user.discount_card &&
          this.order.user.discount_card.discount == 1
        ) {
          return val.action === "Maxdiscount";
        } else {
          return val.action !== "Cashless" && val.action !== "Maxdiscount" &&  val.action !== "cashfiscalless";
        }
      })
      if (this.workshopInfo.show_wof_payment == 1) {
        const cflIndex = this.btns.findIndex((val) => { return val.action === "cashfiscalless"})
        fArr.push(this.btns[cflIndex])
      }
      return fArr
    },
  },
  mounted() {
    this.socketPaymentStatus();
    if (this.refundPayment.state) {
      this.refundOrder();
    }
    if (this.orderInfo.paymentIsProcessing) {
      this.paymentInProgress = true;
      this.watchStateChange(true);
    } else {
      this.watchStateChange();
    }
  },
  watch: {
    centrifugeConnecting(newval) {
      if (newval) {
        this.subscription = null;
      } else {
        console.log("c connect");
        this.socketPaymentStatus();
      }
    },
    order(newval) {
      if (newval && !this.subscriptionDone) {
        this.socketPaymentStatus();
      }
    },
    paymentModal(newval) {
      if (newval) {
        if (this.refundPayment.state) {
          console.log("refund");
          this.refundOrder();
        }
      } else {
        this.$store.commit("clearPaymentRefund");
      }
    },
    inputValueByCash(value) {
      this.setValueInputs("inputValueByCash", "inputValueByCard", value);
    },
    inputValueByCard(value) {
      this.setValueInputs("inputValueByCard", "inputValueByCash", value);
    },
  },
  beforeDestroy() {
    this.subscription.unsubscribe();
  },
  methods: {
    watchStateChange(getFirstState = false) {
      if (
        ((this.lastState && this.paymentState) || getFirstState) &&
        this.lastState < 6 &&
        this.lastState === this.paymentState
      ) {
        console.log("get State");
        const orderId = this.order?.id || this.refundPayment.order.basic.number;
        if (orderId) {
          this.$store
            .dispatch("getAPIPaymentState", orderId)
            .then((resp) => {
              // проверка на тип платежа пока только если по карте 0 значит нал
              if (getFirstState) {
                if (resp.data?.task?.payload?.amount.card === 0) {
                  this.paymentType = "cash";
                }
              }
              this.paymentState = resp.data.state.id;
              this.checkPaymentStatus(resp);
              setTimeout(() => {
                this.watchStateChange();
              }, 10000);
            })
            .catch(() => {
              setTimeout(() => {
                this.watchStateChange();
              }, 10000);
            });
        }
      } else {
        console.log(
          `get State null lastState:${this.lastState}, paymentState:${this.paymentState}`
        );
        this.lastState = this.paymentState; //?.data.message.state.id
        if (!(this.lastState && this.lastState > 5)) {
          setTimeout(() => {
            this.watchStateChange();
          }, 10000);
        }
      }
    },
    async socketPaymentStatus() {
      const orderId = this.order?.id || this.refundPayment.order.basic.number;
      this.subscription = await this.$store.state.login.centrifuge.subscribe(
        `payments.order.${orderId}`,
        (message) => {
          this.subscriptionDone = true;
          console.log("message", message);
          this.paymentState = message.data.message.state.id;
          this.checkPaymentStatus(message.data);
        }
      );
      this.subscription.history().then((message) => {
        if (
          message.result &&
          message.result.publications &&
          message.result.publications.length > 0
        ) {
          this.checkPaymentStatus(
            message.result.publications[message.result.publications.length - 1]
          );
        }
      });
    },
    showErrorInfo(paymentErrorCode) {
      const errException = ["2000", "2004", "4455"];
      const found = errException.some((r) => paymentErrorCode.includes(r));
      return !found;
    },
    showReprint(paymentErrorCode) {
      const errException = ["2000", "2004", "4455"];
      const found = errException.some((r) =>
        paymentErrorCode.includes(String(r))
      );
      return !found;
    },
    disableButton(btn) {
      const buttonDisabledWithAutoAcquiring = ["mix", "card"];
      return (
        (!buttonDisabledWithAutoAcquiring.includes(btn.action) &&
          this.autoAcquiring === false) ||
        this.autoAcquiring === true
      );
    },
    returnHome() {
      this.paymentModal = false;
      this.$router.push("/");
    },
    deleteInterval() {
      clearInterval(this.interval);
      this.interval = null;
    },
    plus(field, type) {
      if (type === "start") {
        this.interval = setInterval(() => {
          this[field]++;
        }, 120);
      } else if (type === "end") {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    setValueInputs(inputOne, inputTwo, value) {
      let thisValue = +value;
      if (!this.validationInputNum(thisValue)) {
        this[inputOne] = 0;
      }
      if (thisValue > this.orderPrice) {
        this[inputOne] = Math.floor(this.orderPrice);
        this[inputTwo] = 0;
      } else {
        this[inputTwo] = Math.floor(this.orderPrice - thisValue);
      }
    },
    validationInputNum(value) {
      return !(isNaN(+value) || +value < 0);
    },
    showMixedInputs() {
      this.showMixedTypeInputs = true;
      this.inputValueByCash = Math.floor(this.orderPrice / 2);
      this.inputValueByCard = Math.floor(
        this.orderPrice - this.inputValueByCash
      );
    },
    refundOrder() {
      this.$store
        .dispatch("refundPayment", this.refundPayment.order.basic.number)
        .then((resp) => {
          console.log("ref resp", resp);
          // this.currentOrder = resp
          this.paymentInProgress = true;
          // this.$store.commit('setPaymentRefund', { state: false, order: this.refundPayment.order })
          // this.getPaymentStatus(resp)
        })
        .catch((e) => {
          console.log("error", e);
          this.$store.commit("setPaymentRefund", {
            state: false,
            order: this.refundPayment.order,
          });
          this.paymentErrorText = [e.message];
          this.paymentErrorJson = JSON.stringify(e.response.data, null, 2);
          this.paymentInProgress = false;
          this.paymentError = true;
          this.paymentSended = false;
          this.disabledButton = false;
        });
    },
    sendPayment(card, cash, paymentType) {
      if (paymentType === "mix") {
        this.showMixedInputs();
      } else {
        let showWof = null
        if (paymentType.toLowerCase() === "cashfiscalless") {
          paymentType = "cash";
          showWof = 1
        }
        if (paymentType.toLowerCase() === "maxdiscount") {
          paymentType = "cash";
          this.inputValueByCash = 0;
        }
        this.showMixedTypeInputs = false;
        this.paymentInProgress = true;
        paymentType = paymentType === "card" ? "Card" : paymentType;
        this.paymentType = paymentType;
        this.disabledButton = true;
        this.$store
          .dispatch("postPayment", {
            orderId: this.order.id,
            electronicalType:
              paymentType.toLowerCase() === "cash"
                ? null
                : paymentType === "mixed"
                ? "Card"
                : paymentType,
            cash: cash,
            electronically: card,
            certificateCode: "test1",
            show_wof_payment: showWof
          })
          .then(() => {
            // this.getPaymentStatus({ original: resp })
            this.disabledButton = false;
          })
          .catch((e) => {
            console.log("error", e);
            this.paymentErrorText = [e.message];
            this.paymentErrorJson = JSON.stringify(e.response.data, null, 2);
            this.paymentInProgress = false;
            this.paymentError = true;
            this.paymentSended = false;
            this.disabledButton = false;
          });
      }
    },
    sendReprint() {
      this.paymentInProgress = true;
      this.paymentError = false;
      this.$store
        .dispatch("postReprintJob", {
          id: this.ctrlJobId,
        })
        .then(() => {
          // this.currentOrder = resp
          // setTimeout(this.getPaymentStatus({original: [this.ctrlJobId]}), 3000)
          setTimeout(this.watchStateChange(true), 3000);
          this.paymentInProgress = true;
          this.disabledButton = false;
        })
        .catch((e) => {
          console.log("error", e);
          this.paymentErrorText = [e.message];
          this.paymentErrorJson = JSON.stringify(e.response.data, null, 2);
          this.paymentInProgress = false;
          this.paymentError = true;
          this.paymentSended = false;
          this.disabledButton = false;
        });
    },
    checkPaymentStatus(res) {
      const resp = res.message || res.data;
      this.$store.commit("setCtrlJobId", resp.id);
      this.paymentStatus = resp.state.description;
      const count = resp.count;
      const current = resp.current;
      this.paymentStatusNum = current;
      this.currentPaymentStatus = current * (100 / count);
      if (count === current) {
        this.paymentInProgress = false;
        this.paymentStatus = null;
        this.paymentCompleted = true;
        if (this.refundPayment.state) {
          this.$store.commit("setPaymentRefund", {
            state: false,
            order: this.refundPayment.order,
          });
        }
      } else if (this.paymentStatusNum === 6) {
        // todo current 2
        if (this.refundPayment.order) {
          this.$store.commit("setPaymentRefund", {
            state: false,
            order: this.refundPayment.order,
          });
        }
        const errorCodeArray = new Set();
        const errorTextArray = new Set();
        if (resp.result && resp.result.term && resp.result.term.e) {
          errorCodeArray.add(resp.result.term.e.error);
          errorTextArray.add(resp.result.term.e.status);
        }
        if (resp.result && resp.result.kkm && resp.result.kkm.cash) {
          errorCodeArray.add(resp.result.kkm.cash.code);
          errorTextArray.add(resp.result.kkm.cash.description);
        }
        if (resp.result && resp.result.kkm && resp.result.kkm.nfdoc) {
          errorCodeArray.add(resp.result.kkm.nfdoc[0].code);
          errorTextArray.add(resp.result.kkm.nfdoc[0].description);
        }
        if (resp.result && resp.result.kkm && resp.result.kkm.card) {
          errorCodeArray.add(resp.result.kkm.card.code);
          errorTextArray.add(resp.result.kkm.card.description);
        }
        this.paymentErrorCode = Array.from(errorCodeArray);
        this.paymentErrorText = Array.from(errorTextArray);
        this.paymentInProgress = false;
        this.paymentError = true;
        const payload = { shiftId: this.shiftData.id, orderId: this.order.id };
        this.$store.dispatch("shift/fetchOrder", payload).then((order) => {
          this.$store.commit("shift/saveOrderInfo", order);
        });
      }
    },
    // todo delete after FULL TEST
    // getPaymentStatus(original) {
    //   console.log('getPaymentStatus', original)
    //   this.socketPaymentStatus()
    //    this.$store.dispatch('fetchReceiptStatus', {original: original.original}).then((resp) => {
    //         console.log(resp)
    //         this.$store.commit('setCtrlJobId', resp.id)
    //         this.paymentStatus = resp.state.description
    //         this.paymentStatusNum = resp.current
    //         this.currentPaymentStatus = resp.current * (100 / resp.count)
    //         if (resp.count === resp.current) {
    //             this.paymentInProgress = false
    //             this.paymentStatus = null
    //             this.paymentCompleted = true
    //             if (this.refundPayment.state) {
    //                 this.$store.commit('setPaymentRefund', {state: false, order: this.refundPayment.order})
    //             }
    //         } else if (resp.current === 6) { // todo current 2
    //             if (this.refundPayment.order) {
    //                 this.$store.commit('setPaymentRefund', {state: false, order: this.refundPayment.order})
    //             }
    //             const errorCodeArray = new Set()
    //             const errorTextArray = new Set()
    //             if (resp.result && resp.result.term && resp.result.term.e) {
    //                 errorCodeArray.add(resp.result.term.e.error)
    //                 errorTextArray.add(resp.result.term.e.status)
    //             }
    //             if (resp.result && resp.result.kkm && resp.result.kkm.cash) {
    //                 errorCodeArray.add(resp.result.kkm.cash.code)
    //                 errorTextArray.add(resp.result.kkm.cash.description)
    //             }
    //             if (resp.result && resp.result.kkm && resp.result.kkm.nfdoc) {
    //                 errorCodeArray.add(resp.result.kkm.nfdoc[0].code)
    //                 errorTextArray.add(resp.result.kkm.nfdoc[0].description)
    //             }
    //             if (resp.result && resp.result.kkm && resp.result.kkm.card) {
    //                 errorCodeArray.add(resp.result.kkm.card.code)
    //                 errorTextArray.add(resp.result.kkm.card.description)
    //             }
    //             this.paymentErrorCode = Array.from(errorCodeArray)
    //             this.paymentErrorText = Array.from(errorTextArray)
    //             this.paymentInProgress = false
    //             this.paymentError = true
    //         } else {
    //             setTimeout(this.getPaymentStatus(original), 600)
    //         }
    //     }).catch((e) => {
    //         console.log('error', e)
    //         if (this.refundPayment.order) {
    //             this.$store.commit('setPaymentRefund', {state: false, order: this.refundPayment.order})
    //         }
    //         this.paymentErrorText = [e.message]
    //         this.paymentErrorJson = JSON.stringify(e.response.data, null, 2)
    //         this.paymentInProgress = false
    //         this.paymentError = true
    //         this.paymentSended = false;
    //         this.disabledButton = false
    //     })
    // },
    // reprint(orderId) {
    //     this.reprintActivated = true;
    //     this.$store
    //         .dispatch('postReprint', {
    //             uuid: this.aqUuid,
    //             orderId: orderId
    //         })
    //         .then(() => {
    //             this.cardPaymentSucceed = false;
    //         })
    //         .catch((e) => {
    //             console.log('Error:', e);
    //             this.paymentSended = false;
    //         })
    // },
    numberWithSpaces(x) {
      return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : "0";
    },
  },
};
</script>

<style lang="scss">
.bold {
  font-weight: 700;
}

.text-big {
  font-size: 30px;
  text-align: center;
  line-height: 1.5;
}

.form-control {
  font-size: 25px;
  width: 70%;
}

button[disabled] {
  pointer-events: none;
  opacity: 0.7;
}

.button-send {
  margin: 30px auto 0;
  display: block;
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgb(0 0 0 / 50%);
  border-radius: 11px;
  font-size: 20px;
  color: #4a4a4a;
  padding: 10px 30px;
}

.control-button {
  border: 1px solid black;
  background-color: #c2dcfa;
  width: 50px;
  height: 50px;
}

.double-play {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  flex-grow: 1;
  padding-bottom: 45px;

  &__content {
    margin: auto;
  }
}
</style>
